//VA: This service is specific to the get employee. user can write their own return implementations of the chosen widget based on the returned data.
const { jvGetQueryParamByName } = require('../../../lib/js/JV.FriendWidget_js_upgrade.webpack.js');

var serviceModule = angular.module('AppCtrl.service', ['AppCtrl.jobvite.service', 'jv.Common.Filters', 'jv.Hire.Url.Service']);
serviceModule.value('CONST', {
    Urls: {
        'getTask': window.jvUrls.source + '/action/task/list',
        'tasksUrl': window.jvUrls.source + '/action/task/'
    }
})
// Makes a call to the backend with the given filter and get the results.
.factory('getTasks', ['$http', 'CONST', 'tasksService', function ($http, CONST, tasksService) {
    // filter is empty for now.
    return function () {
        //return $http.get( CONST.Urls.getTask );
        var _data = angular.copy(tasksService.filters);
        _data.action = 'list';
        _data.output = 'json';

        // cache the ajax call
        if (typeof _gaq != 'undefined') {
            _gaq.push(['_trackEvent', window.JV.PAGE_TYPE, 'getTasks', window._jvselfUser.companyEId]);
        }
        return $http({
            method: 'GET',
            url: CONST.Urls.getTask,
            params: _data
        });
    };
}])
// service for pagination controls, filters.
.factory('tasksService', ['$rootScope', function ($rootScope) {
    var tasksServiceVar = {};
    // maps the user object with the eid.
    tasksServiceVar.userMapper = {};
    // add the logged in user by default.
    tasksServiceVar.selfObject = tasksServiceVar.userMapper[window._jvselfUser.eid] = window._jvselfUser;
    tasksServiceVar.filters = {};
    tasksServiceVar.sortBy = '';
    tasksServiceVar.page = 0;
    tasksServiceVar.setPaginationVariables = function (args) {
        // More variables can be counted.
        this.total = args.total;
        this.pageCount = args.pageCount;
        this.page = args.page;
        //broadcast the message.
        this.broadcastResultCount();
    };

    // Used for navigating between different pages.
    tasksServiceVar.setPage = function (page) {
        this.filters.page = page;
        this.broadcastUpdateResults();
    };

    // User for adding the sortBy filter.
    tasksServiceVar.setSortByFilter = function (key) {
        this.sortBy = key;
        this.setFilters(this.filters);
    };

    // set up by the filter controller. Used for setting the left panel filters.
    tasksServiceVar.setFilters = function (args) {
        this.broadcastPageReinitialization();
        // filter is used by the grid controller to get the updated filter object.
        this.filters = angular.copy(args);
        this.filters.sortBy = this.sortBy;
        this.page = 0;
        this.broadcastUpdateResults();
    };

    tasksServiceVar.broadcastPageReinitialization = function () {
        $rootScope.$broadcast('reinitializePage');
    }


    // broadcast the message to the header controller .
    tasksServiceVar.broadcastResultCount = function () {
        $rootScope.$broadcast('paginationBroadcast');
    };

    // broadcast the message to the grid controller.
    tasksServiceVar.broadcastUpdateResults = function () {
        //triggers the get tasks call.
        $rootScope.$broadcast('updateTasks');
    };
    return tasksServiceVar;
}]);


angular.module('AppCtrl.filter', ['jv.services', 'jv.Common.Filters']);
angular.module('AppCtrl.directive', ['AppCtrl.jobvite.directive', 'AppCtrl.Tasks.directive', 'jv.Common.Modal'])
    .value('modalTemplateUrl', 'htm/common/modal.html');
var taskAppCtrl = angular.module('AppCtrl', ['AppCtrl.service', 'AppCtrl.filter', 'AppCtrl.directive', 'jv.Common.Filters', 'jv.Common.Directives.Datepicker']);

taskAppCtrl.controller('TasksCtrl', ['$scope',
    function ($scope) {
        // VA: set up in the gridCtrl
        // $scope.totalTasks;
        // $scope.returnedTasks;
        $scope.getMilliseconds = function (dateVal) {
            if (dateVal) {
                var d = new Date(dateVal);
                return d.getTime();
            }
        };

        $scope.isStartDisabled = function(start) {
            return start <= 1;
        };

        if (window.isnextGenUIEnabled==='true' && window.self === window.top) {
            document.getElementsByClassName('jv-cand-task-feed')[0].style.padding = '0px 48px';
        }
    }
]);

/**
 * Controller that will work on the filters.
 * @param {Object} $scope
 * @param {Object} closeFilter
 * @param {Object} openFilter
 */
taskAppCtrl.controller('TasksFilterCtrl', ['$scope', 'closeFilter', 'openFilter', 'tasksService',
    function ($scope, closeFilter, openFilter, tasksService) {
        var currentUserEId = tasksService.selfObject.eid;
        //TODO: use filter service for closing and opening the left filter.
        $scope.closeFilter = function () {
            closeFilter();
        };

        $scope.openFilter = function () {
            openFilter();
        };

        //assigning default values.
        $scope.filterObject = $scope.filterObject || {};

        // Pass on the values to the filter.
        var queryList = ['entityType', 'entityIds', 'type', 'overdue', 'ownerEId', 'userEId'];
        for (var i = 0, j = queryList.length; i < j; i++) {
            var _queryValue = jvGetQueryParamByName(queryList[i]);
            if (_queryValue && _queryValue.trim() !== '') {
                if (_queryValue === currentUserEId) {
                    // used to toggle correct radio button
                    $scope.filterObject.userType = queryList[i];
                } else {
                    $scope.filterObject[queryList[i]] = _queryValue;
                }
            }
        }

        $scope.filterObject.type = $scope.filterObject.type || '1';
        $scope.filterObject.overdue = !!$scope.filterObject.overdue; //false or true
        $scope.filterObject.overdueDisabled = false;
        //$scope.filterObject.entityType = '';
        $scope.filterObject.ownerEId = $scope.filterObject.ownerEId || '';
        $scope.filterObject.userEId = $scope.filterObject.userEId || '';
        if (!$scope.filterObject.ownerEId && !$scope.filterObject.userEId) {
            // default to assigned tasks if no id present
            $scope.filterObject.userType = 'ownerEId';
        }

        $scope.$watch('filterObject.type', function (newValue, oldValue) {
            if (newValue == 2) {
                $scope.filterObject.overdue = false;
                $scope.filterObject.overdueDisabled = true;
            } else {
                $scope.filterObject.overdueDisabled = '';
            }
        });

        // the third argument with $watch looks for changes in the whole object. https://groups.google.com/forum/?fromgroups#!topic/angular/-Tx8U9Xm07k
        $scope.$watch('filterObject', function (newValue, oldValue) {
            var filters = angular.copy(newValue);
            // set user id back to correct type
            filters[filters.userType] = currentUserEId;
            tasksService.setFilters(filters);
        }, true);
    }
]);


taskAppCtrl.controller('TasksHeaderCtrl', ['$scope', 'tasksService', 'CONST', '$rootScope',
    function ($scope, tasksService, CONST, $rootScope) {

        $scope.start = $scope.end = $scope.total = $scope.totalPages = 0;
        $scope.page = -1;

        // Listener for page reinitialization, when the filters change.
        $scope.$on('reinitializePage', function () {
            $scope.page = 0;
            $scope.total = 0;
        });

        /**
         * navigates the grid
         * @param {Boolean} next: true for the next, false for previous
         */
        $scope.paginate = function (next) {
            next = !!next;
            // check if there is no next/previous page.
            if (($scope.page == $scope.totalPages && next) || ($scope.page == 0 && !next)) {
                return;
            }
            //TODO: VA: only the TasksHeaderCtrl manages the pages. So if user clicks on next/previous multiple times it can cause issues.
            tasksService.setPage(next ? $scope.page + 1 : $scope.page - 1);
        };

        /**
         * sorting keys for the backend.
         */
        $scope.sortFilters = {
            '1': {
                'text': i18n['JV_DATE_CREATED'],
                'key': 'createDate'
            },
            '2': {
                'text': i18n['JV_DATE_COMPLETED'],
                'key': 'completionDate'
            },
            '3': {
                'text': i18n['JV_TASKS_DATE_DUE'],
                'key': 'dueDate'
            }
        };

        // default value of the sorter;
        $scope.currentSorter = $scope.sortFilters['3'];
        tasksService.setSortByFilter($scope.currentSorter.key);

        function updatePaginationVars() {
            if ($scope.total != 0) {
                $scope.start = ($scope.page * $scope.pageCount) + 1;
                $scope.end = ($scope.totalPages == $scope.page) ? $scope.total : ($scope.page * $scope.pageCount) + $scope.pageCount;
            } else {
                // total count is zero
                $scope.start = 0;
                $scope.end = 0;
            }
        }

        $scope.$on('paginationBroadcast', function () {
            $scope.total = tasksService.total;
            $scope.pageCount = tasksService.pageCount;
            // check if there is no next page, page is 0 based.
            $scope.totalPages = Math.ceil($scope.total / $scope.pageCount) - 1;
            $scope.page = tasksService.page;
            updatePaginationVars();
        });

        $scope.$watch('page', function () {
            updatePaginationVars();
        });

        $scope.dropDown = false;
        $scope.toggleOptions = function () {
            $scope.dropDown = !$scope.dropDown;
        };

        $scope.setSort = function (sortKey) {
            // make the call for the sorting here.
            $scope.currentSorter = $scope.sortFilters[sortKey];
            if (!$scope.dropDown)
                $scope.dropDown = !$scope.dropDown;
            tasksService.setSortByFilter($scope.currentSorter.key);
        };
        //tasksService.setSortByFilter( $scope.currentSorter.key );
    }
]);

taskAppCtrl.controller('TasksGridCtrl', ['$scope', '$http', 'getTasks', 'tasksService', 'CONST', 'returnObjectForId', '$rootScope', '$filter', 'massageRequestForSaving', 'jvHireUrlService',
    function ($scope, $http, getTasks, tasksService, CONST, returnObjectForId, $rootScope, $filter, massageRequestForSaving, jvHireUrlService) {
        $scope.ifAccessToContactDetails = _ifAccessToContactDetails;
        $scope.ifAccessToCandidateDetails = _ifAccessToCandidateDetails;
        // backup
        var _backupResults = [];
        $scope.resultExists = false;
        // get the results and update the ui.
        function getEntityTasks() {
            var _ajaxTasksCall = getTasks();
            // get the tasks on the page load
            _ajaxTasksCall.then(function (res) {
                var result = res.data;
                var _ifNoFilterPresent = jvGetQueryParamByName('noFilter');
                if (_ifNoFilterPresent == 'true' && result.resultList.length > 5) {
                    //$scope.results = angular.copy(_backupResults.slice(0, 5 ) );
                    _backupResults = result.resultList.slice(0, 5);
                } else {
                    _backupResults = result.resultList;
                }

                if (typeof result.users != 'undefined') {
                    var _users = result.users;
                    for (var user in _users) {
                        tasksService.userMapper[user] = _users[user];
                    }
                }

                $scope.resultExists = false;
                if(angular.isDefined(_backupResults)) {
                    for (var i = 0, j = _backupResults.length; i < j; i++) {
                        //VA: Hack
                        _backupResults[i].duplicateOwnerEId = _backupResults[i].ownerEId;
                        // to show/hide the assignment in edit mode.
                        _backupResults[i].assignToSomeone = !!_backupResults[i].duplicateOwnerEId;
                        _backupResults[i].ellipseContent = true;
                        _backupResults[i].typecheckbox = _backupResults[i].type == 1 ? false : true;
                        _backupResults[i].entityName = (_backupResults[i].entityName && _backupResults[i].entityName.trim() === '') ? 'Name not found' : _backupResults[i].entityName;
                        $scope.resultExists = true;
                    }
                
                    $scope.results = angular.copy(_backupResults);
                    $rootScope.totalTasks = parseInt((!!result.resultCount ? result.resultCount : 0));
                    $rootScope.returnedTasks = _backupResults.length;
                    tasksService.setPaginationVariables({
                        total: parseInt((!!result.resultCount ? result.resultCount : 0)),
                        pageCount: parseInt((!!result.pageCount ? result.pageCount : 10)),
                        page: parseInt((!!result.page ? result.page : 0))
                    });
                }
            });
        }

        $scope.viewTask = function (eid, taskType) {
            switch (taskType) {
                case 'Contact':
                    parent.location = window.jvUrls.source + '/person/contactDetails.html?ids=' + eid + '&activeTabOrdinal=5';
                    break;
                case 'Application':
                    parent.location = jvHireUrlService.getApplicationDetailsUrl(eid);
                    break;
                default:
                    // default
            }
        };

        $scope.viewEntity = function (eid, taskType) {
            switch (taskType) {
                case 'Contact':
                    parent.location = window.jvUrls.source + '/person/contactDetails.html?ids=' + eid;
                    break;
                case 'Application':
                    parent.location = jvHireUrlService.getApplicationDetailsUrl(eid, false);
                    break;
                default:
                    // default
            }
        };

        $scope.$on('updateTasks', function () {
            getEntityTasks();
        });

        $scope.changeContent = function (entity) {
            entity.ellipseContent = !entity.ellipseContent;
        };

        /*
            For a given 'entity', fills the property 'type' for a given 'property'
            eg. entity['customName'] = 'someValue'
         */

        $scope.getObjectName = function (entity, type, property) {
            var callback = function (fullName) {
                entity[type] = fullName;
            };
            returnObjectForId(entity[property], callback);
        };

        $scope.changeMode = function (index) {
            for (var i = 0; i < $scope.results.length; i++) {
                if (i != index) {
                    $scope.results[i] = angular.copy(_backupResults[i]);
                    $scope.results[i].editMode = false;
                }
            }
            // editMode :  true: show the edit ui, false: hide the edit ui.
            var ownerEId = $scope.results[index].duplicateOwnerEId;
            $scope.results[index].editMode = !($scope.results[index].editMode);
            if (!$scope.results[index].editMode) {
                $scope.results[index] = angular.copy(_backupResults[index]);
            } else {
                // edit Mode is true.
                $scope.results[index].ownerEId = ownerEId;
            }
        };

        $scope.getDueDate = function (entityEId) {

        };

        $scope.showDeleteDialog = function (entity) {
            //$rootScope.$broadcast('showDeleteDialog', entity);
            $rootScope.$broadcast('showDeleteDialog', entity);
        };

        $scope.$on('deleteTask', function (event, entity) {
            $scope.deleteTask(entity);
        });

        $scope.deleteTask = function (entity) {
            var _url = CONST.Urls.tasksUrl + entity.SId;
            // cache the ajax call
            if (typeof _gaq != 'undefined') {
                _gaq.push(['_trackEvent', window.JV.PAGE_TYPE, 'deleteTasks', window._jvselfUser.companyEId]);
            }
            $http({
                'method': 'DELETE',
                url: _url
            }).then(function () {
                // fire another query to get the latest.
                getEntityTasks();
            }, function () {
                // something went wrong.
            });
        };

        $scope.ifDeletionPermitted = function (entity) {
            return (entity.userEId == window._jvselfUser.eid);
        };

        $scope.ifEditPermitted = function (entity) {
            return (entity.userEId == window._jvselfUser.eid || entity.duplicateOwnerEId == window._jvselfUser.eid);
        };

        $scope.changeStatus = function (entity, index, triggerComplete) {
            if (entity.typecheckbox == true) {
                entity.type = 2;
                if (!!triggerComplete) {
                    $scope.completeTask(index);
                }
            } else {
                entity.type = 1;
            }
        };

        $scope.completeTask = function (index) {
            var _url = CONST.Urls.tasksUrl + $scope.results[index].SId;
            // cache the ajax call
            if (typeof _gaq != 'undefined') {
                _gaq.push(['_trackEvent', window.JV.PAGE_TYPE, 'completeTask', window._jvselfUser.companyEId]);
            }
            $http({
                'method': 'PUT',
                url: _url
            }).then(function () {
                // fire another query to get the latest.
                getEntityTasks();
            }, function () {
                // something went wrong.
            });
        };

        $scope.ifOverdue = function (timeInMillis) {
            var taskDate = new Date(timeInMillis).getTime();
            var currentDate = new Date().getTime();
            if (currentDate > taskDate) {
                return true;
            }
            return false;
        };
        /**
         * save the task updated.
         * @param {Object} entity
         */
        $scope.saveTask = function (entity) {
            //var _url = CONST.Urls.tasksUrl + entity.SId;
            var _url = CONST.Urls.tasksUrl;
            var _entity = angular.copy(entity);
            // assign the task to the user himself if the user unchecks the 'Assign to Someone' checkbox
            _entity.ownerEId = _entity.assignToSomeone ? _entity.ownerEId : window._jvselfUser.eid;
            // the ownerEId has a separate scope, so we need to access it explicitely with the child scope.
            _entity = massageRequestForSaving(_entity);
            // cache the ajax call
            if (typeof _gaq != 'undefined') {
                _gaq.push(['_trackEvent', window.JV.PAGE_TYPE, 'saveTask', window._jvselfUser.companyEId]);
            }
            $http({
                'headers': {
                    'Content-Type': 'application/x-www-form-urlencoded'
                    //'Content-Type': 'application/json'
                },
                'method': 'POST',
                'url': _url,
                'data': $.param(_entity)
            }).then(function () {
                // fire another query to get the latest.
                getEntityTasks();
            }, function () {
                // something went wrong.
            });
        };
    }
]);

taskAppCtrl.controller('TasksOverlayController', ['$scope', '$rootScope',
    function ($scope, $rootScope) {

        $scope.ifDeleteVisible = false;
        $scope.ifNavigateAwayVisible = false;
        $scope.deleteEntity = null;

        $scope.$on('showDeleteDialog', function (event, entity) {
            $scope.showDeleteDialog(entity);
        });

        $scope.$on('showNavigateAwayDialog', function () {
            $scope.showNavigateAwayDialog();
        });

        $scope.showDeleteDialog = function (entity) {
            $scope.ifDeleteVisible = true;
            $scope.deleteEntity = entity;
        };

        $scope.showNavigateAwayDialog = function () {
            $scope.ifNavigateAwayVisible = true;
        };

        $scope.close = function () {
            $scope.ifDeleteVisible = false;
            $scope.ifNavigateAwayVisible = false;
            $scope.deleteEntity = null;
        };

        $scope.deleteTask = function () {
            $rootScope.$broadcast('deleteTask', angular.copy($scope.deleteEntity));
            $scope.close();
        };

        $scope.leavePage = function () {

        };

    }
]);

// Initialize the app with the document ready function.
$(document).ready(function () {
    // select2
    $('#jv-taskType').select2($.extend({}, {
        placeholder: 'All',
        allowClear: true,
        data: [{
            id: 'application',
            text: i18n['JV_TASKS_APPLICATION']
        }, {
            id: 'contact',
            text: i18n['ADMIN_TASKS_CONTACT']
        }]
    }, window._jvPluginDefaults.select2));
    //Date integration.
    $('.jv-datePicker').datepicker({
        // Provided the fallback if i18n[dates] is not enabled
        dateFormat: window._jvselfUser.locale.userDate.shortDatePicker() || 'mm/dd/yy'
    });
    var intervalHeight = setInterval(function () {
        if (top === self) {
            clearInterval(intervalHeight);
        } else {
            try {
                //parent.adjustTasksHeight($('.jv-pageTitle').height() + $('.jv-contentContainer').height());
                parent.adjustTasksHeight($('.container').height());
            } catch (e) {}
        }
    }, 300);
});


$(window).on('beforeunload', function () {
    var _scope = $("div[ng-controller='TasksGridCtrl']").scope();
    if(angular.isDefined(_scope.results)){
        for (var i = 0; i < _scope.results.length; i++) {
            if (_scope.results[i].editMode) {
                return 'The changes you made will be lost if you navigate away from this page. Are you sure you want to leave this page?';
            }
        }
    }
});